import { pick } from 'lodash';

import type { BillingAccount } from '@ctct/domain-layer';
import { applicationStateSessionStorage } from '@ctct/infrastructure-layer';
import type { IPaymentMethodsSlice, PaymentMethodsPageStore } from '@ctct/state-client-layer';

export class PaymentMethodsDataPersistenceService {
  constructor(private pageStore: PaymentMethodsPageStore, private billingAccount: BillingAccount) {}

  api() {
    return {};
  }

  data() {
    return {};
  }

  handlers() {
    return {};
  }

  public persistPaymentMethodsData() {
    const state = pick(this.pageStore.getState(), [
      'selectedMethod',
      'currentPaymentMethod',
      'paymentMethodCanBeUpdated',
      'creditCardConnected',
      'creditCardToken',
      'echeckConnected',
      'echeckToken',
      'paypalAgreementId',
      'paypalConnected',
      'amazonPayToken',
      'amazonPayCheckoutSession',
      'amazonPayConnected',
      'isStripeSubmitted',
    ] as (keyof IPaymentMethodsSlice)[]);

    applicationStateSessionStorage.savePaymentMethodsState(state, this.billingAccount.getCustomerId());
  }
}
